export default "__VITE_ASSET__BNwAIVCB__"